import {Box, Container, Stack, HStack, Flex, Skeleton, SkeletonCircle} from '@chakra-ui/react'
import React from 'react'
import ImageGallerySkeleton from '../../../components/image-gallery/skeleton'
import useElementScreenPosition from '../../../hooks/use-element-screen-position'
import SkeletonText from '../../../components/skeleton-text'

const CockpitSkeleton = () => {
    const {
        setRef: setHeadingRef,
        position: {top: headingTop}
    } = useElementScreenPosition()

    const stickyProps = {
        position: {lg: 'sticky'},
        top: {lg: `${headingTop}px`}
    }

    const sidebarSizeProps = {
        // figma is based on 12 column grid
        // this is the rough equivalent in chakra
        flexBasis: {
            lg: 'calc(25% + 0.5rem)',
            xl: 'calc(25% + 0.875rem)',
            '2xl': 'calc(25% + 0.75rem)'
        },
        // prevents children from stretching above the flex-basis size
        minWidth: 0
    }

    return (
        <Container layerStyle="page" variant="no-padding">
            <Flex
                ref={setHeadingRef}
                direction={{base: 'column', lg: 'row'}}
                gap={{base: 6, '2xl': 8}}
                alignItems={{lg: 'flex-start'}}
            >
                <Box flex={1} marginX={{base: -4, lg: 0}} {...stickyProps}>
                    <ImageGallerySkeleton />
                </Box>

                <Stack spacing={6} order={{lg: -1}} {...stickyProps} {...sidebarSizeProps}>
                    <Stack spacing={2}>
                        <Skeleton height={6} />
                    </Stack>

                    <Stack spacing={2}>
                        <SkeletonText />
                    </Stack>

                    <Box display={{base: 'none', lg: 'block'}}>
                        <Skeleton height={16} />
                    </Box>
                </Stack>

                <Stack
                    spacing={6}
                    {...stickyProps}
                    {...sidebarSizeProps}
                    display={{base: 'none', lg: 'block'}}
                >
                    <Skeleton height={2} width="25%" />
                    <HStack spacing={4}>
                        {[1, 2, 3].map((_, index) => (
                            <Skeleton key={index} height={8} width={16} />
                        ))}
                    </HStack>

                    <Skeleton height={2} width="25%" />
                    <HStack spacing={4}>
                        {[1, 2, 3, 4, 5, 6].map((_, index) => (
                            <SkeletonCircle key={index} size={12} />
                        ))}
                    </HStack>

                    <Skeleton height={14} />

                    <HStack justify="space-between" align="start">
                        <Skeleton height={2} width="25%" />
                        <Skeleton height={10} width="25%" />
                    </HStack>

                    <Skeleton height={14} />
                    <Skeleton height={14} />
                    <Skeleton height={14} />

                    <SkeletonText />
                </Stack>
            </Flex>
        </Container>
    )
}

export default CockpitSkeleton
